import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, startWith, takeWhile, tap } from 'rxjs/operators';
import { FormValueService } from 'src/app/shared/service/form/form-value.service';

@Component({
  selector: 'app-dynamic-select',
  templateUrl: './dynamic-select.component.html',
  styleUrls: ['./dynamic-select.component.scss'],
})
export class DynamicSelectComponent implements OnInit {
  @Input() field: any;
  form: FormGroup;
  alive = true;
  options: any[] = [];
  filteredOptions!: Observable<any[]>;
  fieldToCheck: any;
  nameFilter ?: any;
  constructor(
    private formGroupDirective: FormGroupDirective,
    private formValueService: FormValueService
  ) {
    this.form = formGroupDirective.control;
  }

  ngOnInit(): void {
    this.listenForLinkData();
    this.options = this.field.options;
     this.nameFilter = this.field.nameFilter;
    // Suscribirse a los cambios de valor del control '
    this.filteredOptions = this.form.get(this.field.fieldName)!.valueChanges.pipe(
      startWith(''),
      map((value) => {
        const label = typeof value === 'string' ? value : value[this.nameFilter];
        return this._filter(label || '')
      }),
  );

    // Esta a la escucha de cualquier cambio que se haga en el formulario
    this.formValueService.setForm(this.form);
    this.subscribeToFieldOptions();
    this.getRfc()
    this.getLimits()
  }

  _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter((option) =>
      String(option[this.nameFilter] ?? '').toLowerCase().includes(filterValue)
    );
  }

  ngOnDestroy() {
    this.alive = false;
  }

  listenForLinkData() {
    if (!this.field?.link) {
      return;
    }
  }

  dataSelected(e: any, key?: string) {
    if(key){
    
      this.form.patchValue({
        [this.field.fieldToSelection.key]: e.option.value.Clave,
        [this.field.fieldToSelection.id]: e.option.value.Id,
        [this.field.fieldName]: e.option.value[this.nameFilter],
      
      });
    }else{
         this.form.patchValue({
      // [this.field.fieldToSelection]: e.option.value.value,
      // [this.field.fieldName]: e.option.value.label,
      [this.field.fieldToSelection]: e.option.value.Id,
      [this.field.fieldName]: e.option.value[this.nameFilter],
    
    });
    }
  }

  // Funcion que esta a la escucha de cualquier cambio de la data para las opciones
  private subscribeToFieldOptions(): void {
    this.formValueService.fieldOptions$
      .pipe(
        takeWhile(() => this.alive),
        filter(({ fieldName: field }) => field === this.field.fieldName)
      )
      .subscribe(({ options }) => {
        this.form.patchValue({[this.field.fieldName]: '' });
        this.options = [];
        this.options = options;
        this.filteredOptions = this.form.get(this.field.fieldName)!.valueChanges.pipe(
            startWith(''),
            map((value) => {
              const label = typeof value === 'string' ? value : value[this.nameFilter];
              return this._filter(label || '')
            }),
        );
      });
  }

  private getRfc():void{
    if (this.field.fieldName === 'RFC') {
      this.form.get(this.field.fieldName)!.valueChanges
      .pipe(
        debounceTime(3000),
      )
      .subscribe(
        value => {
            this.formValueService.emitRFC(value);

        }
      )
    }
  }

  private getLimits():void{
    if (this.field.fieldName === 'Norma') {
      this.form.get(this.field.fieldName)!.valueChanges
      .pipe(
        debounceTime(1000),
      )
      .subscribe(
        value => {
            this.formValueService.emitRFC(value);

        }
      )
    }
  }
}
